import { IconButton, Modal } from "@telegram-apps/telegram-ui";
import "./TUIModalHeader.css";

export const TUIModalHeader = () => {
  return (
    <Modal.Header
      className="tui-modal-header"
      after={
        <Modal.Close>
          <IconButton
            className="tui-modal-header__close-button"
            size="s"
            mode="bezeled"
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 1L1 11M1 1L11 11"
                stroke="#8E8E93"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </IconButton>
        </Modal.Close>
      }
    ></Modal.Header>
  );
};
